import React, { Component } from 'react'
import { connect } from 'react-redux'

import { translation } from '../../../utils/helpers'
import { setHelpIconPopupUpdates } from '../../../actions/common'

import './helpIcon.scss'

// Components
import Icon from '../icon'
import { ElementIcons } from '../icons'

class HelpIcon extends Component {
  constructor (props) {
    super(props)

    this.state = {
      currentUpdate: -1,
      styleFix: {}
    }

    this.toggleShow = this.toggleShow.bind(this)
  }

  componentDidUpdate () {
    if (this.state.currentUpdate === this.props.updates && Object.keys(this.state.styleFix).length === 0) {
      let fix = this.fixIsOutsideOfScreen()
      if (Object.keys(fix).length !== 0) {
        this.setState({
          styleFix: fix
        })
      }
    }
  }

  toggleShow (e) {
    e.stopPropagation() // Doesn't work
    // console.log('HelpIcon onClick triggered!', e)

    const resetUpdate = () => {
      this.setState({
        currentUpdate: -1,
        styleFix: {}
      })
      window.removeEventListener('click', resetUpdate)
    }

    let newUpdate = this.props.updates + 1
    if (this.state.currentUpdate === this.props.updates) {
      this.setState({
        currentUpdate: -1
      })
    } else {
      this.setState({
        currentUpdate: newUpdate
      })
      window.setTimeout(() => { window.addEventListener('click', resetUpdate) }, 10)
    }

    this.props.setHelpIconPopupUpdates(newUpdate)
  }

  getStyle () {
    let className = 'element-help-icon'
    if (this.props.white) className += '__white'
    return className
  }

  fixIsOutsideOfScreen () {
    let elem = document.querySelector('.element-help-icon__popover')
    let style = {}
    if (elem !== undefined && elem !== null) {
      var bounding = elem.getBoundingClientRect()
      // outside of screen to right
      if (bounding.right > (window.innerWidth || document.documentElement.clientWidth)) {
        let moveX = window.innerWidth ? bounding.right - window.innerWidth : bounding.right - document.documentElement.clientWidth
        let calc = bounding.width / 2 + moveX
        style = { transform: `translateX(${-calc}px)` }
      }
      // outside of screen to left
      if (bounding.left < 0) {
        let calc = bounding.width / 2 + bounding.left
        style = { transform: `translateX(${-calc}px)` }
      }
    }
    return style
  }

  render () {
    if (!this.props.helpText) return null
    let helpText = this.props.helpText
    if (typeof helpText === 'number') helpText = translation(helpText)

    // Size doesn't match standard sizes, ...nvm. added tiny
    return (
      <div className={this.getStyle()} onClick={this.toggleShow}>
        <Icon icon={this.props.altIcon !== null ? this.props.altIcon : ElementIcons.Info} size={this.props.size} injectSvg />
        {this.state.currentUpdate === this.props.updates && (
          <div className='element-help-icon__popover' style={this.state.styleFix}>{helpText}</div>
        )}
      </div>
    )
  }
}

HelpIcon.defaultProps = {
  size: 't',
  helpText: null,
  altIcon: null,
  white: false
}

function mapStateToProps (state) {
  return {
    updates: state.common.helpIconPopupUpdates
  }
}

export default connect(mapStateToProps, {
  setHelpIconPopupUpdates
})(HelpIcon)




// WEBPACK FOOTER //
// ./src/app/shared/elements/helpIcon/index.js